
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"2","cy":"2","r":"2","transform":"translate(10 10)"}}),_c('path',{attrs:{"d":"M12 6c-5.76 0-9 6-9 6s3.24 6 9 6 9-6 9-6-3.24-6-9-6z"}})])])
          )
        }
      }
    